import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductBoxListItem } from "../../product.types";
import { requestGetProductBoxesList } from "./getProductBoxesList.request";

const useGetProductBoxesList = (
  requestParams: GetListRequestParams,
  productVariantId?: string,
  options?: QueryOptions<
    GetListResponse<ProductBoxListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: [
      "products",
      "admin",
      "all-boxes",
      requestParams,
      productVariantId
    ],
    enabled: !!productVariantId,
    queryFn: async () =>
      await requestGetProductBoxesList(requestParams, productVariantId),
    onError: toastServerError,
    ...options
  });

  return { boxesItemsList: data?.data, meta: data?.meta, ...rest };
};

export default useGetProductBoxesList;
